import React, { Component } from 'react';
import { TextField, MenuItem } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';


class BasicDetailsDomain extends Component {
    state = {
        domain: '',
        selectListDomain: {},
        error: false
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ domain: nextProps.name, error: nextProps.nameError, selectListDomain: nextProps.selectListDomain });
    }

    onChange = (e) => {
        let error = false;
        if (typing.isEmpty(e.target.value)) {
            error = true;
        }
        this.setState({ domain: e.target.value, error: error });
    };

    onBlur = (e) => {
        this.props.onAttributeUpdate({ domain: this.state.domain }, this.state.error, e.currentTarget.id)
    }

    render() {
        const selectListDomain = this.state.selectListDomain;
        const domain = this.state.domain;
        const error = this.state.error;
        let selectDomain = <MenuItem key={0} value={""}>No domains</MenuItem>;


        if (Object.keys(selectListDomain).length > 0) {
            selectDomain = selectListDomain.data.map((item, index) =>
                <MenuItem value={item.DOMAIN} key={index}>{item.DOMAIN}</MenuItem >
            );
        }

        return (
            <TextField
                label="DOMAIN"
                id="domain"
                select={true}
                style={{ marginTop: 8, marginBottom: 8 }}
                fullWidth
                margin="normal"
                error={error}
                value={domain}
                onBlur={this.onBlur}
                onChange={this.onChange}
                InputLabelProps={{
                    shrink: true,
                }}>
                {selectDomain}
            </TextField>
        )
    }
};

export default BasicDetailsDomain;